import type { PageProps } from "@inertiajs/core"
import { Head, Link } from "@inertiajs/react"
import { DealsTable } from "@/components/deals-table"
import { Button } from "@/components/ui/button"
import { ArrowLeft, UserCog, Users } from "lucide-react"
import type { User } from "@/types/serializers"
import type Deal from "@/types/serializers/Deal"
import { VerticalTable } from "@/components/vertical-table"

interface Props extends PageProps {
  user: User & { id: number; provider: string; teams: Array<{ id: number; name: string }> }
  teams: Team[]
  deals: Deal[]
}

export default function Show({ user, teams, deals }: Props) {
  return (
    <>
      <Head title={`User: ${user.name || user.email}`} />
      <div className="">
        {/* Header with navigation */}
        <div className="flex items-center border-b border-b-gray-100 p-4 mb-0">
          <div className="flex items-center space-x-4">
            <Link href="/users">
              <Button variant="outline" size="icon">
                <ArrowLeft className="h-4 w-4" />
              </Button>
            </Link>
            <div>
              <h1 className="text-2xl font-bold tracking-tight">
                {user.name || user.email}
              </h1>
              <p className="text-sm text-muted-foreground">
                {user.email}
              </p>
            </div>
          </div>
        </div>

        {/* Main content */}
        <div className="grid grid-cols-1 md:grid-cols-3 min-h-screen">
          {/* Main content area */}
          <div className="md:col-span-2 p-6 pt-2">
            <DealsTable
              title='Deals'
              showActions={false}
              hiddenColumns={["buyer.name"]}
            />
          </div>

          {/* Right sidebar */}
          <div className="space-y-6 p-6 bg-gray-50/50 border-l border-l-gray-100 p-4 md:col-span-1 min-h-full">
            <h2 className="text-lg font-semibold mb-2">Teams</h2>
            <ul className="space-y-2">
            {teams.map((team) => (
              <li key={team.id}>
                <Link href={`/teams/${team.id}`} className="font-normal hover:underline flex items-center gap-2">
                  <Users className="h-4 w-4 text-muted-foreground" />
                  Team {team.name}
                </Link>
              </li>
            ))}
            </ul>
          </div>
        </div>
      </div>
    </>
  )
} 